import dynamicLocalization from "@/mixins/dynamic-localization";
import Iconized from "@/components/iconized/index";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    mobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [dynamicLocalization],
  components: { Iconized },
  data() {
    return {
      disabled: this.data.disabled && true,
      external: this.data.external && true,
      routerInfo: this.data.routerInfo || null,
      href: this.data.href || null,
      title: this.data.title,
      icon: this.data.icon || "link",
      source: this.data.source || false,
    };
  },
  methods: {
    confirmExternal(e) {
      if (
        !confirm(
          this.$t("EXTERNAL_SITE_WARNING", { siteTitle: this.$dt(this.title) })
        )
      ) {
        return e.preventDefault();
      }
    },
  },
};
